<!-- 中医 -->
<template>
  <div>
		<!-- <div style="font-size: 16px;">
			生化检查
			<el-tag type="danger" size="mini" style="margin-left: 10px">未完成</el-tag>
		</div> -->

		<div style="text-align: center;">
			<el-button type="primary" :loading="isLoading" @click="onAssess">生成评估</el-button>
		</div>		
  </div>

</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';

export default {  
	mixins: [mixin],
	props: {
		// 问卷是否已完成
		questSucc: Boolean,
		// 评估id
		id: Number,
		patientId: Number,
	},
	data(){
		return {
			noSidebar: true,
			isLoading: false,
		}
	},
	created() {},
	methods: {
		async onAssess() {

			if (!this.questSucc) {
				return this.$message.warning('请先完成评估问卷');
			}
			this.assessForm();
		},		
		async assessForm() {
			if (this.isLoading) { return; }
			this.isLoading = true;
			const res = await api.assessCustomerEval({id: this.id, params: {}});
			this.isLoading = false;
			if (res.code != 1000) {return this.$message.error(res.message);}
			this.$emit('succ');
		},		
	}
}
</script>

